import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoGoldie = () => {
  return (
    <g>
      <path d="m14.092 8.7862a1.9006 1.9006 0 0 0 -.4508.0561 5.81 5.81 0 0 0 -4.6-4.2858c-.1-.0181-.1908-.0314-.2928-.0443a1.9049 1.9049 0 0 1 .85-1.7536l-.1284-.3219s-1.573.4888-1.7553 1.8349c-.0784-.3663-.812-.8245-1.1752-.9114l-.1806.2913a1.266 1.266 0 0 1 .5987.9052 5.81 5.81 0 0 0 -4.5988 4.2856 1.8847 1.8847 0 1 0 .2376 3.5819 5.7775 5.7775 0 0 0 .6123 1.139l1.564-1.0544-.0133-.0174a3.853 3.853 0 0 1 -.7094-2.0933 2.787 2.787 0 0 1 .7113-2.2146 2.0953 2.0953 0 0 1 3.1347.3991h.2074a2.0953 2.0953 0 0 1 3.1347-.3991 2.787 2.787 0 0 1 .7113 2.2146 3.853 3.853 0 0 1 -.7091 2.0933l-.0133.0174 1.564 1.0544a5.7786 5.7786 0 0 0 .6123-1.139 1.8842 1.8842 0 1 0 .6884-3.6381zm-12.22 2.44a.556.556 0 0 1 0-1.1121.5608.5608 0 0 1 .3116.0961 8.4468 8.4468 0 0 0 .0593.8735.5563.5563 0 0 1 -.3711.1424zm12.2565 0a.5563.5563 0 0 1 -.3709-.1425 8.4467 8.4467 0 0 0 .0592-.8735.5551.5551 0 0 1 .8673.4611.5547.5547 0 0 1 -.5559.5548z" />
    </g>
  );
};

export default withIcon(IconLogoGoldie);
